'use strict';

var units = Object.freeze({
        KJ: 'KJ',
        GJ: 'GJ',
        GC: 'GC',
        KWH: 'KWH',
        MWH: 'MWH',
        L: 'L',
        M_3: 'M_3',
        DEVICE_UNIT: 'DEVICE_UNIT',
        UNDEFINED: 'UNDEFINED'
    });

define('shared/utilities/defs/units', [], function () {
    return units;
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/utilities/defs/units.js
// module id = 11
// module chunks = 0 1